import React from 'react'
import { graphql } from 'gatsby'
import LinkedinIcon from '../../../ui/icons/socials/linkedinIcon'
import InstagramIcon from '../../../ui/icons/socials/instagramIcon'
import TwitterIcon from '../../../ui/icons/socials/twitterIcon'
import FacebookIcon from '../../../ui/icons/socials/facebookIcon'
import YoutubeIcon from '../../../ui/icons/socials/youtubeIcon'
import Social from '../../../ui/icons/socials/social'
import { Socials } from '../mapper'

type FirmSocialsProps = {
  socials: Socials
  header?: boolean
  color: string | null
  additionalClasses?: string
}

const FirmSocials: React.FC<FirmSocialsProps> = ({
  socials,
  header = false,
  color,
  additionalClasses = '',
}) => {
  const headerClasses = header ? 'mt-1 w-full' : ''

  return (
    socials && (
      <div className={`${headerClasses} ${additionalClasses || ''}`}>
        <div className="flex flex-row items-center justify-center w-full gap-4 text-white lg:gap-1">
          {socials.twitter && (
            <Social
              link={socials.twitter}
              icon={<TwitterIcon />}
              color={color}
            />
          )}
          {socials.youtube && (
            <Social
              link={socials.youtube}
              icon={<YoutubeIcon />}
              color={color}
            />
          )}
          {socials.linkedin && (
            <Social
              link={socials.linkedin}
              icon={<LinkedinIcon />}
              color={color}
            />
          )}
          {socials.facebook && (
            <Social
              link={socials.facebook}
              icon={<FacebookIcon />}
              color={color}
            />
          )}
          {socials.instagram && (
            <Social
              link={socials.instagram}
              icon={<InstagramIcon />}
              color={color}
            />
          )}
        </div>
      </div>
    )
  )
}

export default FirmSocials

export const query = graphql`
  fragment FirmSocials on STRAPI_ACCOUNTING_FIRM {
    social {
      twitter
      youtube
      linkedin
      facebook
      instagram
    }
  }
`
